//frontend/src/applications/administrator/AdministratorApp.jsx

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import AppLayout from "../../components/layout/AppLayout";
import Sidebar from "../../components/layout/Sidebar/Sidebar";

import { administratorNavigation } from "./navigation";
import AdministratorRoutes from "./routes";

function getActiveItem(pathname) {
  if (pathname.startsWith("/calendar")) return "calendar";
  if (pathname.startsWith("/map")) return "map";
  if (pathname.startsWith("/finance")) return "finance";
  if (pathname.startsWith("/accounting")) return "accounting";
  if (pathname.startsWith("/clients")) return "clients";
  if (pathname.startsWith("/suppliers")) return "suppliers";
  if (pathname.startsWith("/products")) return "products";
  if (pathname.startsWith("/expeditors")) return "expeditors";
  if (pathname.startsWith("/orders")) return "orders";
  if (pathname.startsWith("/tracking")) return "tracking";
  if (pathname.startsWith("/help")) return "help";
  if (pathname.startsWith("/request-search")) return "request-search";
  if (pathname.startsWith("/admin/eco-calculator")) return "eco-calculator";
  if (pathname.startsWith("/users")) return "users";
  return "dashboard";
}

export default function AdministratorApp({
  user,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedOrders, setSelectedOrders] = useState([]);

  return (
    <AppLayout
      user={user}
      sidebar={
        <Sidebar
          items={administratorNavigation}
          active={getActiveItem(location.pathname)}
          onNavigate={navigate}
        />
      }
      selectedOrders={selectedOrders}
      onSelectOrders={setSelectedOrders}
    >
      <AdministratorRoutes
        selectedOrders={selectedOrders}
        setSelectedOrders={setSelectedOrders}
      />
    </AppLayout>
  );
}
